module.exports = __webpack_public_path__ + "img/business-plan-icon.cab11e68.svg";